// class configListener extends Event {
//     constructor() {
//         super('changed');
//         this.lastTimestamp = null;
//         this.key = "config:update";
//         this.timer = setInterval(this.loop.bind(this), 1e3);
//     }
//     loop() {
//         const lastTimestamp = localStorage.getItem(this.key);
//         if (lastTimestamp == null) {
//             this.notify();
//             document.dispatchEvent(this);
//         }
//         if (this.lastTimestamp != lastTimestamp) {
//             this.lastTimestamp = lastTimestamp;
//             document.dispatchEvent(this);
//         }
//     }
//     notify() {
//         localStorage.setItem(this.key, Date.now());
//     }
//     stop() {
//         clearInterval(this.timer);
//     }
// }
function configListener() {
    let ev = new Event("changed")
    this.lastTimestamp = null;
    this.key = "config:update";
    this.loop = () => {
        const lastTimestamp = localStorage.getItem(this.key);
        if (lastTimestamp == null) {
            this.notify();
            document.dispatchEvent(ev);
        }
        if (this.lastTimestamp != lastTimestamp) {
            this.lastTimestamp = lastTimestamp;
            document.dispatchEvent(ev);
        }
    }
    this.notify = () => {
        localStorage.setItem(this.key, Date.now());
    }
    this.stop = () => {
        clearInterval(this.timer);
    }
    this.timer = setInterval(this.loop.bind(this), 1e3);
}

export default configListener;